import { render, staticRenderFns } from "./AvaliacoesDespesasGerais.vue?vue&type=template&id=18001224"
import script from "./AvaliacoesDespesasGerais.vue?vue&type=script&lang=js"
export * from "./AvaliacoesDespesasGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports